<template>
    <span v-if="hasBudgets" @click="onOpen" class="cursor-pointer nobr">
        {{ FormatHelper.number(budget, $t('lang.main.currency.sign')) }} <i class="fa fa-caret-down ml-1 report_keyword_budget__caret"></i>
    </span>
    <span v-else class="nobr">
        {{ FormatHelper.number(budget, $t('lang.main.currency.sign')) }}
    </span>
    <AdaptersOverlayPanel
        ref="overlay"
        :pt="{
            content: {style: 'min-width: 250px'}
        }"
    >
        <div class="report_keyword_budget__container">
            <div class="report_keyword_budget__header">
                <span>{{ $t('lang.report.keyword_budget.header_type') }}</span>
                <span>{{ $t('lang.report.keyword_budget.header_cost') }}</span>
            </div>
            <div v-for="(budgetValue, budgetKey) in budgets" class="report_keyword_budget__item">
                <span>{{ $t('lang.report.keyword_budget.label_' + budgetKey) }}</span>
                <span>{{ FormatHelper.number(budgetValue, $t('lang.main.currency.sign')) }}</span>
            </div>
        </div>
    </AdaptersOverlayPanel>
</template>

<script>
import AdaptersOverlayPanel from "keysso/component/adapters/OverlayPanel.vue";
import {FormatHelper} from "keysso/helpers/FormatHelper";

/**
 * Прогноз бюджета по фразе для ячейки таблицы отчёта:
 * значение при 100% трафика, по клику — разбивка по объёму трафика.
 */
export default {
    name: "ReportKeywordBudget",
    props: {
        budget: {
            type: Number,
            required: true,
        },
        /**
         * @type{{
         *      [budgetKey]: Number
         * }}
         */
        budgets: {
            type: Object,
            required: true,
        },
    },
    computed: {
        FormatHelper() {
            return FormatHelper;
        },
        hasBudgets() {
            return Object.keys(this.budgets).length;
        },
    },
    methods: {
        onOpen(e) {
            if (this.$refs.overlay.isOpen) {
                this.$refs.overlay.hide();
                return;
            }
            this.$refs.overlay.show(e);
        },
    },
    components: {
        AdaptersOverlayPanel,
    },
}
</script>

<style scoped>
.report_keyword_budget__caret {
    color: #A4B1BE;
}
.report_keyword_budget__container {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.report_keyword_budget__header {
    font-size: 11px;
    color: #A4B1BE;
}
.report_keyword_budget__header,
.report_keyword_budget__item {
    display: flex;
    justify-content: space-between;
}
.report_keyword_budget__item {
    padding: 12px 10px;
    gap: 24px;
}
.report_keyword_budget__item:nth-child(even) {
    background-color: #F0F4F7;
}
.report_keyword_budget__item span {
    font-size: 14px;
    color: #495057;
}
</style>
